export enum Namespaces {
    header = "header",
    footer = "footer"
}


